import { render } from "./StandardKosten.pug?vue&type=template&id=d41566e4&lang=pug"
import script from "./StandardKosten.js?vue&type=script&lang=js"
export * from "./StandardKosten.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__